import CreateRetailProfile from './CreateRetailProfile';

export default CreateRetailProfile;
